export { useCompaniesIndustries } from './useCompaniesIndustries';
